import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { getOptionsFields } from './helper';
import { checkModalOnlySubscription } from '../../helper';

const FieldsOptions = ({ isLoadingProvider, errorProvider, form, modal, providerForm, dispatchServiceData }) => {
  const fields = useMemo(() => getOptionsFields(form, providerForm, modal), [form, providerForm, modal])
  const isSubscription = checkModalOnlySubscription(modal);

  /*
    Задача: https://www.notion.so/perfectpanel/Subscriptions-x16-PR-42-373c46983d37459285899e74621ebee1
    Скрываем все поля только для Subscription услуги (type = 100) с типом Manual
    Для Subscription reselling (type = 101) - оставляем поля
   */
  if (isSubscription) {
    return null;
  }

  if (isLoadingProvider || errorProvider) {
    return null;
  }

  return fields.map((FieldComponent, index) => (
    <FieldComponent
      form={form}
      key={index}
      dispatchServiceData={dispatchServiceData}
    />
  ));
}

FieldsOptions.propTypes = {
  isLoadingProvider: PropTypes.bool,
  errorProvider: PropTypes.string,
  providerForm: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  form: PropTypes.object,
  modal: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldsOptions;
